"use strict";

import intlTelInput from "intl-tel-input";

let KommoPageShow = function () {
    let iti;
    const MAX_DIGITS = 15;
    // Private functions
    let main = function () {

        let ipCountryCode = 'us'; // Код страны по IP с безопасным значением по умолчанию

        const phoneInput = document.querySelector("#phone");

        const getIpCountryCode = () => {
            return fetch("https://ipinfo.io/json?token=46cb83c89a0d67")
                .then((resp) => resp.ok ? resp.json() : null)
                .then((resp) => resp?.country?.toLowerCase() || 'us')
                .catch(() => 'us');
        };

        const initPhoneInput = (countryCode = 'us') => {
            if (!phoneInput) {
                return;
            }

            iti = intlTelInput(phoneInput, {
                initialCountry: countryCode,
                separateDialCode: true,
                nationalMode: false,
                autoPlaceholder: "aggressive",
                loadUtils: () => import("intl-tel-input/build/js/utils.js"),
                formatOnDisplay: true,
            });

            // Form lives in a hidden modal iframe; dial-code width is often 0 on init.
            // setCountry(sameIso) is a no-op, so measure and set padding manually.
            const refreshDialPadding = () => {
                const selected = phoneInput.closest(".iti")?.querySelector(".iti__selected-country");
                const width = selected?.offsetWidth || 0;
                if (width > 0) {
                    phoneInput.style.paddingLeft = `${width + 6}px`;
                }
            };

            requestAnimationFrame(() => {
                requestAnimationFrame(refreshDialPadding);
            });
            setTimeout(refreshDialPadding, 300);

            const visibilityObserver = new IntersectionObserver((entries) => {
                if (entries.some((entry) => entry.isIntersecting && entry.intersectionRatio > 0)) {
                    refreshDialPadding();
                    // Keep observing briefly: modal/iframe may report visible before layout settles.
                    setTimeout(() => {
                        refreshDialPadding();
                        visibilityObserver.disconnect();
                    }, 100);
                }
            });
            visibilityObserver.observe(phoneInput);

            phoneInput.addEventListener("input", function () {
                // Удаляем все нецифровые символы
                let digitsOnly = this.value.replace(/\D/g, "");

                // Ограничиваем длину
                if (digitsOnly.length > MAX_DIGITS) {
                    digitsOnly = digitsOnly.slice(0, MAX_DIGITS);
                }

                this.value = digitsOnly;
            });

            phoneInput.addEventListener("keydown", function (e) {
                // Разрешаем: Backspace, Delete, Tab, Escape, Enter, стрелки
                if (
                    ["Backspace", "Delete", "Tab", "Escape", "Enter", "ArrowLeft", "ArrowRight"].includes(e.key) ||
                    (e.ctrlKey || e.metaKey)
                ) {
                    return;
                }

                // Разрешаем только цифры
                if (!/^\d$/.test(e.key)) {
                    e.preventDefault();
                }
            });
        };

        if (phoneInput) {
            getIpCountryCode().then((countryCode) => {
                ipCountryCode = countryCode;
                initPhoneInput(countryCode);
            });
        }



        const form      = document.getElementById('kommo-form');
        const submitBtn = form.querySelector('.send-button');

        const site_code_element = document.querySelector('#site-code');
        let site_code = site_code_element.dataset.code

        let recaptchaLoading = null;

        const loadRecaptcha = () => {
            if (window.grecaptcha && typeof window.grecaptcha.execute === 'function') {
                return Promise.resolve();
            }

            if (recaptchaLoading) {
                return recaptchaLoading;
            }

            if (!site_code) {
                return Promise.reject(new Error('Missing reCAPTCHA site code'));
            }

            recaptchaLoading = new Promise((resolve, reject) => {
                const existing = document.querySelector('script[data-recaptcha-api]');
                if (existing) {
                    existing.addEventListener('load', () => {
                        if (window.grecaptcha?.ready) {
                            window.grecaptcha.ready(resolve);
                        } else {
                            resolve();
                        }
                    });
                    existing.addEventListener('error', reject);
                    return;
                }

                const script = document.createElement('script');
                script.src = `https://www.google.com/recaptcha/api.js?render=${site_code}`;
                script.async = true;
                script.dataset.recaptchaApi = '1';
                script.onload = () => {
                    if (window.grecaptcha?.ready) {
                        window.grecaptcha.ready(resolve);
                    } else {
                        resolve();
                    }
                };
                script.onerror = reject;
                document.head.appendChild(script);
            });

            return recaptchaLoading;
        };

        // Preload reCAPTCHA on first interaction with the form
        form?.addEventListener('focusin', () => {
            loadRecaptcha().catch(() => {});
        }, { once: true });

        // ваш CSRF-токен (Laravel)
        const csrf =
            document.querySelector('input[name="_token"]')?.value ||
            document.querySelector('meta[name="csrf-token"]')?.content;

        submitBtn.addEventListener('click', (e) => {
            e.preventDefault();

            if (!site_code) {
                console.log('error captcha code');
                return false;
            }

            function formSubmit(){
                console.log('formSubmit')


                console.log('Raw value:', form.phone.value.trim());
                console.log('Formatted:', iti?.getNumber());

                console.log(iti);

                if (iti && iti.isValidNumber()) {
                    console.log("Форматированный номер:", iti.getNumber());
                } else {
                    console.log("Неверный номер или iti не инициализирован");
                }


                /* ---------- собираем данные ---------- */
                const selectedCountryData = iti?.getSelectedCountryData?.() || {};
                const data = {
                    name            : form.name.value.trim(),
                    email           : form.email.value.trim(),
                    phone           : iti?.getNumber() || form.phone.value.trim(),
                    company         : form.company.value.trim(),
                    question        : form.question.value.trim(),
                    user_dial_code  : selectedCountryData.dialCode || '',
                    user_country_iso: selectedCountryData.iso2 || '',
                    ip_country_iso  : ipCountryCode || 'us',
                };

                /* ---------- валидация ---------- */
                if (!data.name || !data.email || !form.terms.checked) {

                    console.log('validation error');
                    //alert( 'Please fill in all required fields (Name, Email, Acceptance of the Privacy Policy).');
                    Swal.fire({
                        text: 'Please fill in all required fields (Name, Email, Acceptance of the Privacy Policy).',
                        icon: 'warning',
                        buttonsStyling: false,
                        confirmButtonText: 'ОК',
                        customClass: { confirmButton: 'btn btn-primary' }
                    });
                    return;
                }

                /* ---------- UI: блокируем кнопку ---------- */
                submitBtn.disabled = true;
                submitBtn.textContent = 'Sending…';

                /* ---------- POST /forms/kommo ---------- */
                axios.post('/forms/kommo', data, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'X-CSRF-TOKEN': csrf
                    }
                })
                    .then((response) => {

                        console.log(response.data);

                        // ожидаем: { status:"OK", uid:"...", contact:123 }
                        if (String(response.data.status).toUpperCase() === 'OK') {
                            //alert('Thank you! Your request has been submitted.');
                            Swal.fire({
                                text: 'Thank you! Your request has been submitted.',
                                icon: 'success',
                                buttonsStyling: false,
                                confirmButtonText: 'ОК',
                                customClass: { confirmButton: 'btn btn-primary me-2' }
                            });
                            form.reset();                    // очищаем форму
                        } else {
                            throw new Error('Unexpected API answer');
                        }
                    })
                    .catch((error) => {
                        console.error(error);
                        //alert('Submission failed. Please try again later.');
                        Swal.fire({
                            text: 'Submission failed. Please try again later.',
                            icon: 'error',
                            buttonsStyling: false,
                            confirmButtonText: 'Закрыть',
                            customClass: { confirmButton: 'btn btn-primary' }
                        });
                    })
                    .finally(() => {
                        submitBtn.disabled = false;
                        submitBtn.textContent = 'Send';
                    });
            }

            loadRecaptcha()
                .then(() => new Promise((resolve) => {
                    grecaptcha.ready(resolve);
                }))
                .then(() => grecaptcha.execute(site_code, {action: 'register'}))
                .then(function(token) {
                    //console.log('reCaptcha submit, token = ', token);
                    console.log('reCaptcha submitted');

                    let sendData = {
                        token: token
                    };

                    submitBtn.disabled = true;
                    submitBtn.textContent = 'Sending…';

                    let request = $.ajax({
                        url: '/verify-captcha',
                        headers: {
                            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                        },
                        method: "POST",
                        data: JSON.stringify(sendData),
                        dataType: "json", // expected format for response
                        contentType: "application/json", // send as JSON
                    });

                    request.done(function( result ) {
                        console.log(result)
                        if (result.hasOwnProperty('success')){
                            if (result.success === true){
                                submitBtn.disabled = false;
                                submitBtn.textContent = 'Send';
                                formSubmit();

                            }
                        }

                    });

                    request.fail(function( jqXHR, textStatus ) {
                        console.log(textStatus)
                        submitBtn.disabled = false;
                        submitBtn.textContent = 'Send';
                    });
                })
                .catch((error) => {
                    console.error(error);
                    submitBtn.disabled = false;
                    submitBtn.textContent = 'Send';
                });
        });

    };


return {
    // public functions
    init: function () {
        main();
    }
};
}();

document.addEventListener('DOMContentLoaded', function() {
    KommoPageShow.init();
}, false);

